var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDoorOpenIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 62,
  height: 48,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F22C2C",
  fillRule: "evenodd",
  d: "M5 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM4 5.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zM20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm-1 1.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F22C2C",
  d: "M9.855 10.16a.584.584 0 0 1-.011.765l-.933 1.021H12.5c.278 0 .5.243.5.548s-.222.547-.5.547H8.91l.934 1.021a.59.59 0 0 1 .011.766.47.47 0 0 1-.717.012L7 12.5l2.138-2.34a.47.47 0 0 1 .717.012z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F22C2C",
  d: "M14.145 10.16a.584.584 0 0 0 .011.765l.933 1.021h-2.588c-.28 0-.501.243-.501.548s.222.547.5.547h2.59l-.934 1.021a.59.59 0 0 0-.011.766.47.47 0 0 0 .717.012L17 12.5l-2.138-2.34a.47.47 0 0 0-.717.012z"
})));
export default SvgDoorOpenIcon;